const initialState = {
  leftNavOpen: false,
  searchMobileOpen: false,
  subMenuOpen: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'OPEN_LEFT_NAV':
      return { ...state, leftNavOpen: true }
    case 'CLOSE_LEFT_NAV':
      return { ...state, leftNavOpen: false }
    case 'TOGGLE_NAV':
      return { ...state, leftNavOpen: !state.leftNavOpen }
    case 'TOGGLE_SEARCH':
      return { ...state, searchMobileOpen: !state.searchMobileOpen }
    case 'TOGGLE_SUBMENU':
      return { ...state, subMenuOpen: !state.subMenuOpen }
    case 'CLEAR_UI':
      return { ...state, leftNavOpen: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./services/ui-state/reducer/index.js